/* One merchant-owned calendar; text adapters preserve each existing header and offer. */
(function () {
  'use strict';
  const DEFAULT = { title: 'EVERYDAY SAVINGS', compactTitle: 'BUNDLE & SAVE', bundleLabel: 'BUNDLE' };
  const VISIT_DURATION_MS = (3 * 60 + 17) * 60 * 1000;
  const VISIT_STORAGE_KEY = 'oculabs_sale_visitor_v1';

  function resolve(calendar, now) {
    const fallback = Object.assign({}, DEFAULT, calendar && calendar.fallback, { id: 'fallback', phase: 'fallback', deadline: null });
    if (!calendar || calendar.version !== 1 || calendar.enabled !== true || !Number.isFinite(now)) return fallback;
    const entries = [calendar.override].concat(Array.isArray(calendar.campaigns) ? calendar.campaigns : []);
    for (const campaign of entries) {
      if (!campaign || campaign.enabled === false || !campaign.id || !campaign.title || !campaign.compactTitle || !campaign.bundleLabel) continue;
      const start = Date.parse(campaign.startsAt), end = Date.parse(campaign.endsAt);
      const early = campaign.earlyAccessAt ? Date.parse(campaign.earlyAccessAt) : start;
      if (![start, end, early].every(Number.isFinite) || early > start || start >= end || now < early || now >= end) continue;
      const phase = now < start ? 'early' : 'sale';
      return Object.assign({}, campaign, { phase, deadline: phase === 'early' ? start : end });
    }
    return fallback;
  }

  function clockParts(deadline, now) {
    const seconds = Math.max(0, Math.min(VISIT_DURATION_MS / 1000, Math.ceil((deadline - now) / 1000)));
    const values = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
    return { values: values.map(value => String(value).padStart(2, '0')), labels: ['Hrs', 'Mins', 'Secs'] };
  }

  function visitWindow(campaignId, now, saved) {
    if (saved && saved.campaignId === campaignId && Number.isFinite(saved.startedAt) &&
        saved.startedAt <= now && saved.expiresAt === saved.startedAt + VISIT_DURATION_MS && saved.expiresAt > now) return saved;
    return { campaignId, startedAt: now, expiresAt: now + VISIT_DURATION_MS };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { resolve, clockParts, visitWindow, VISIT_DURATION_MS };
  if (typeof document === 'undefined') return;
  const configNode = document.querySelector('[data-ocu-sale-config]');
  if (!configNode || window.ocuSaleCalendar) return;
  let calendar;
  try { calendar = JSON.parse(configNode.textContent); } catch (_) { calendar = null; }

  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const rid = (root, id) => root.querySelector('[data-rid="' + id + '"]');
  let state, key, timers = [], bundleFrame, visitor;
  const salePrefixes = new WeakMap();
  const bannerSuffixes = new WeakMap();
  const bannerMax = new WeakMap();

  function loadVisit(campaignId, now) {
    let saved;
    try { saved = JSON.parse(localStorage.getItem(VISIT_STORAGE_KEY)); } catch (_) { /* Storage can be unavailable in private browsers. */ }
    const next = visitWindow(campaignId, now, saved);
    try { localStorage.setItem(VISIT_STORAGE_KEY, JSON.stringify(next)); } catch (_) { /* Continue with this page's window. */ }
    return next;
  }

  function nativeHeader() {
    document.querySelectorAll('[data-ocu-sale-standard]').forEach(root => {
      const heading = root.querySelector('.countdown-heading strong') || root.querySelector('.countdown-heading');
      const label = state.phase === 'early' ? (state.earlyCompactTitle || state.compactTitle) : state.compactTitle;
      text(heading, label + ':');
      const clock = root.querySelector('[data-ocu-sale-timer]');
      if (clock) timers.push({ root: clock, cells: [...clock.querySelectorAll('.countdown-timer__number')], labels: [...clock.querySelectorAll('.countdown-timer__label')] });
    });
  }

  function resiliaHeaders() {
    document.querySelectorAll('.vb-sec--vab-r-countdown,.vb-sec--vb-countdown').forEach(root => {
      const calming = root.classList.contains('vb-sec--vb-countdown');
      text(rid(root, 'dd169012-35bb-45eb-a22e-57cfca7e0700')?.querySelector('p'), window.innerWidth < 750 ? state.compactTitle : state.title);
      const offer = calming ? 'Bundle & Save' : 'Subscribe & Save 20%';
      const subtitle = state.phase === 'early' ? 'Early access · ' + offer : offer;
      text(rid(root, 'e755ce2e-2226-4814-b644-84b4688072eb')?.querySelector('p'), subtitle);
      const cells = ['110f15b7-1758-42e9-b3df-2cacc06f0c61', '226c9892-fc3d-4ceb-9ff2-ac81436b6f96', '4e38ca9b-16e5-4de2-a98b-3d8183733721'].map(id => rid(root, id)?.querySelector('span'));
      const labels = ['6fb85b69-4a17-4886-8146-5a059cce0be8', '82fe6f92-c2ae-4cf5-a2cb-4fef6bc2036c', 'ab00d6dd-9fcd-4611-9953-3a5cff2daae0'].map(id => rid(root, id)?.querySelector('p'));
      if (cells.every(Boolean) && labels.every(Boolean)) {
        const clock = cells[0].parentElement.parentElement.parentElement;
        clock.dataset.ocuSaleTimer = '';
        timers.push({ root: clock, cells, labels });
      }
    });
  }

  function tmrwHeader() {
    document.querySelectorAll('#oculabs-tmrw-premium ._body_1hibw_51 ._text_1hibw_87').forEach(row => {
      const before = row.querySelector('._textBefore_1hibw_147');
      if (before) {
        // Keep the existing flag, two text spans, and currency selector.
        let label = [...before.childNodes].find(node => node.nodeType === Node.TEXT_NODE);
        if (!label) { label = document.createTextNode(''); before.appendChild(label); }
        label.nodeValue = (window.innerWidth < 750 ? state.compactTitle : state.title) + ' ';
      }
      text(row.querySelector('._textAfter_1hibw_159'), state.phase === 'early' ? 'EARLY ACCESS' : state.phase === 'sale' ? 'BUNDLE & SAVE' : 'DAILY CARE, BETTER VALUE');
    });
  }

  function endLabel() {
    return state.phase === 'early' ? 'EARLY ACCESS' : 'BUNDLE & SAVE';
  }

  function bundles() {
    if (!state) return;
    document.querySelectorAll('.vb-page .price-rows > .save-label').forEach(label => {
      const prefix = [...label.childNodes].find(node => node.nodeType === Node.TEXT_NODE && /(?:STOP WAITING SALE|BUNDLE OFFER)\s*-\s*Save/.test(node.nodeValue)) || salePrefixes.get(label);
      if (prefix) {
        salePrefixes.set(label, prefix);
        const value = state.bundleLabel + ' · Save\u00a0';
        if (prefix.nodeValue !== value) prefix.nodeValue = value;
      }
    });
    document.querySelectorAll('.md-banner__title').forEach(title => {
      const current = title.textContent.trim();
      const original = current.match(/^(?:GLOBAL PET SALE|TURKEY TAIL\+ (?:STARTER|ROUTINE) SALE)(.*)$/);
      if (original) bannerSuffixes.set(title, original[1]);
      if (!bannerSuffixes.has(title)) return;
      text(title, state.bundleLabel + bannerSuffixes.get(title));
      const sub = title.parentElement.querySelector('.md-banner__sub');
      if (sub) {
        if (!bannerMax.has(sub)) bannerMax.set(sub, /MAX SAVINGS/.test(sub.textContent));
        text(sub, (bannerMax.get(sub) ? 'MAX SAVINGS · ' : '') + endLabel());
      }
    });
  }

  function headers() {
    timers = [];
    nativeHeader(); resiliaHeaders(); tmrwHeader(); bundles();
    document.documentElement.dataset.ocuSaleId = state.id;
    document.documentElement.dataset.ocuSalePhase = state.phase;
  }

  function tick() {
    const now = Date.now();
    state = resolve(calendar, now);
    // The calendar selects the copy; the visitor countdown also runs between campaigns.
    // Reuse an active window across pages/reloads. Only a new page visit after expiry
    // (or a new campaign) starts another window; an open page never loops its timer.
    if (!visitor || visitor.campaignId !== state.id) visitor = loadVisit(state.id, now);
    const nextKey = state.id + ':' + state.phase + ':' + state.deadline;
    if (nextKey !== key) { key = nextKey; headers(); }
    const deadline = visitor ? visitor.expiresAt : now;
    const showTimer = Boolean(visitor && deadline > now);
    const parts = clockParts(deadline, now);
    timers.forEach(timer => {
      timer.root.style.visibility = showTimer ? '' : 'hidden';
      timer.root.setAttribute('aria-hidden', showTimer ? 'false' : 'true');
      timer.root.setAttribute('role', 'timer');
      timer.root.setAttribute('aria-live', 'off');
      timer.root.setAttribute('aria-label', showTimer ? state.title + ', promotional countdown: ' + parts.values.map((value, index) => Number(value) + ' ' + parts.labels[index]).join(', ') : '');
      timer.cells.forEach((cell, index) => {
        text(cell, parts.values[index]);
        if (cell.hasAttribute('aria-label')) cell.setAttribute('aria-label', Number(parts.values[index]) + ' ' + parts.labels[index]);
        const group = cell.closest('[role="group"]');
        if (group) group.setAttribute('aria-label', parts.labels[index]);
        text(timer.labels[index], parts.labels[index]);
      });
    });
  }

  function init() {
    tick();
    setInterval(tick, 1000);
    // GemPages/Kaching inserts and rebuilds the original-page offer badges asynchronously.
    const main = document.querySelector('#MainContent');
    if (main) new MutationObserver(() => {
      if (bundleFrame) return;
      bundleFrame = requestAnimationFrame(() => { bundleFrame = null; bundles(); });
    }).observe(main, { childList: true, characterData: true, subtree: true });
    window.addEventListener('resize', () => { headers(); tick(); }, { passive: true });
    document.addEventListener('shopify:section:load', () => { headers(); tick(); });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
    window.addEventListener('storage', event => {
      if (event.key !== VISIT_STORAGE_KEY || !state || !event.newValue) return;
      try {
        const shared = JSON.parse(event.newValue);
        if (visitWindow(state.id, Date.now(), shared) === shared) { visitor = shared; tick(); }
      } catch (_) { /* Ignore an incomplete or invalid storage event. */ }
    });
  }
  window.ocuSaleCalendar = Object.freeze({ resolve, clockParts });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
